import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams } from '@angular/common/http';
// tslint:disable-next-line:import-blacklist
import { CommonfilterService } from './commonfilter.service';
import { projectConstants } from '../shared/constants/project-constants';
import { Observable } from 'rxjs';


const headers = new HttpHeaders({
  'Content-Type': 'application/json; charset=utf-8',
  'Access-Control-Allow-Origin': '*', 'Access-Control-Allow-Credentials': 'true',
  'Access-Control-Allow-Methods': 'GET, POST, PATCH, PUT, DELETE, OPTIONS'
});

@Injectable()
export class CouponService {


  couponUrl = '/superadmin/rest/mgmt/jc';
  jCashUrl = '/superadmin/rest/mgmt/jcash/offer';
  jOfferStatUrl = '/superadmin/rest/mgmt/jcash/offer/stat';
  jOfferUrl = '/superadmin/rest/mgmt/jcash/offer/stat';
  domainNames: any[];
  subDomainNames: any[];
  licenseNames: any[];
  channelsNames: any[];
  domainIds: any;
  sectors: any = [];
  subDomainIds: any = [];
  customerData: any = {}
  offerData: any = {}
  spData: any = {}
  constructor(private http: HttpClient, private commonService: CommonfilterService) {
    this.commonService.getServiceSectors()
      .subscribe(res => {
        this.sectors = res;
      });

  }
  getTotalFilterCount(filter: any): any {
    return this.http.get(this.couponUrl + '/count?' + filter, { headers });
  }
  getCoupons(
    filter, sortOrder,
    pageNumber, pageSize = 10): Observable<any> {

    return this.http.get(this.couponUrl + '?' + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  deleteCoupon(couponId) {
    return this.http.delete(this.couponUrl + '/' + couponId, { headers });

  }
  disableCoupon(couponId, alertMsg) {
    return this.http.put(this.couponUrl + '/' + couponId + '/disable', alertMsg, { headers });
  }
  pushCoupon(couponId, alertMsg) {
    return this.http.post(this.couponUrl + '/' + couponId + '/push', alertMsg, { headers });
  }
  createJaldeeCoupon(data) {
    return this.http.post(this.couponUrl, data, {headers: headers });
  }
  updateJaldeeCoupon(data, couponId) {
    return this.http.put(this.couponUrl + '/' + couponId, data, { headers });
  }
  getCouponDetails(couponCode) {
    return this.http.get(this.couponUrl + '/' + couponCode, { headers });
  }
  createJaldeeCash(data) {
    return this.http.post(this.jCashUrl, data, {headers: headers });
  }
  getJaldeeCash(
    filter, sortOrder,
    pageNumber, pageSize = 10): Observable<any> {

    return this.http.get(this.jCashUrl + '?' + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  getJaldeeCash_byOffer(
    filter, sortOrder,
    pageNumber, pageSize = 10): Observable<any> {
    return this.http.get(this.jOfferUrl + '/' + filter, {
      params: new HttpParams()
        .set('asc', sortOrder)
        .set('from', pageNumber.toString())
        .set('count', pageSize.toString())
    });
  }
  getCashTotalFilterCount(filter: any): any {
    return this.http.get(this.jCashUrl + '/count?' + filter, { headers });
  }
  changeStatusCash(offerId,status): Observable<any> {
    return this.http.put(this.jCashUrl + '/' + offerId + '/' + status, {headers});
  }
  getCashDetails(id) {
    return this.http.get(this.jCashUrl + '/' + id, { headers });
  }
  updateJaldeeCash(data, offerId) {
    return this.http.put(this.jCashUrl + '/' + offerId, data, { headers });
  }
  getOfferTodayStat() {
    return this.http.get(this.jOfferStatUrl + '/date/TODAY', { headers });
  }
  getOfferLastWeekStat() {
    return this.http.get(this.jOfferStatUrl + '/date/LAST_WEEK', { headers });
  }
  getOfferTotalStat() {
    return this.http.get(this.jOfferStatUrl + '/date/TOTAL', { headers });
  }
  getOfferSpStat(id) {
    return this.http.get(this.jOfferStatUrl +'/id'+ '/' + id, { headers });
  }
  getTargetedDomains(domains) {
    this.domainNames = [];
    for (let i = 0; i < domains.length; i++) {
      for (let j = 0; j < this.sectors.length; j++) {
        if (domains[i] === this.sectors[j].domain) {
          this.domainNames.push({ 'domainName': this.sectors[j].displayName });
        }

      }


    }
    return this.domainNames;

  }
  getAllDomains() {
    console.log('sectors............' + JSON.stringify(this.sectors));
    this.domainNames = [];
    for (let j = 0; j < this.sectors.length; j++) {
      this.domainNames.push({ 'domainName': this.sectors[j].displayName });
    }
    return this.domainNames;

  }
  getAllDomainsId(domains) {

    this.domainIds = [];
    for (let j = 0; j < domains.length; j++) {
      this.domainIds.push(domains[j].domain);
    }
    return this.domainIds;

  }

  getTargetedSubDomainNames(subDomains) {
    this.subDomainNames = [];
    for (let i = 0; i < subDomains.length; i++) {
      for (let j = 0; j < this.sectors.length; j++) {
        for (let k = 0; k < this.sectors[j].subDomains.length; k++) {
          if (subDomains[i].split('_')[1] === this.sectors[j].subDomains[k].subDomain) {
            this.subDomainNames.push({ 'subDomainName': this.sectors[j].subDomains[k].displayName });
          }
        }
      }


    }

    return this.subDomainNames;

  }
  getAllSubDomains() {
    this.subDomainNames = [];
    for (let j = 0; j < this.sectors.length; j++) {
      for (let k = 0; k < this.sectors[j].subDomains.length; k++) {
        this.subDomainNames.push({ 'subDomainName': this.sectors[j].subDomains[k].displayName });
      }
    }
    return this.subDomainNames;


  }
  getAllSubDomainNamesofDomain(targetDomain) {
    this.subDomainNames = [];
    for (let i = 0; i < targetDomain.length; i++) {
      for (let j = 0; j < this.sectors.length; j++) {
        for (let k = 0; k < this.sectors[j].subDomains.length; k++) {
          if (this.sectors[j].domain === targetDomain[i]) {
            this.subDomainNames.push({ 'subDomainName': this.sectors[j].subDomains[k].displayName });
          }
        }
      }
    }
    return this.subDomainNames;
  }

  getLicenseNames(license, license_packages) {
    this.licenseNames = [];
    for (let i = 0; i < license_packages.length; i++) {
      for (let j = 0; j < license.length; j++) {
        if (license[j] === license_packages[i].pkgId) {
          this.licenseNames.push({ 'license': license_packages[i].displayName });
        }
      }
    }
    return this.licenseNames;
  }
  getAllLicenseNames(license_packages) {
    this.licenseNames = [];
    for (let i = 0; i < license_packages.length; i++) {
      this.licenseNames.push({ 'license': license_packages[i].displayName });
    }
    return this.licenseNames;

  }
  getCouponStatistics(jcCode) {
    return this.http.get(this.couponUrl + '/' + jcCode + '/stats', { headers: headers });

  }
  getAllServiceSectors() {

    this.domainIds = [];
    this.domainIds.push(0);
    for (let j = 0; j < this.sectors.length; j++) {
      this.domainIds.push(this.sectors[j].domain);
    }
    console.log(this.domainIds)
    return this.domainIds;
  }

  getAllServiceSubSectors() {
    this.subDomainIds = [];
    this.subDomainIds.push(0);
    for (let j = 0; j < this.sectors.length; j++) {
      for (let k = 0; k < this.sectors[j].subDomains.length; k++) {
        this.subDomainIds.push(this.sectors[j].domain + '_' + this.sectors[j].subDomains[k].subDomain);
      }
    }
    return this.subDomainIds;
  }
  getSelectedSubSectors(domain, subdomains) {
    this.subDomainIds = [];
    if (subdomains.includes('ALL')) {
      for (let i = 0; i < domain.length; i++) {
        for (let j = 0; j < this.sectors.length; j++) {
          if (domain[i] === this.sectors[j].domain) {
            for (let k = 0; k < this.sectors[j].subDomains.length; k++) {
              this.subDomainIds.push(this.sectors[j].domain + '_' + this.sectors[j].subDomains[k].subDomain);
            }
          }
        }
      }
    } else {
      for (let i = 0; i < subdomains.length; i++) {
        for (let j = 0; j < this.sectors.length; j++) {
          for (let k = 0; k < this.sectors[j].subDomains.length; k++) {
            if (subdomains[i] === this.sectors[j].subDomains[k].subDomain) {
              this.subDomainIds.push(this.sectors[j].domain + '_' + this.sectors[j].subDomains[k].subDomain);
            }
          }
        }

      }
    }
      return this.subDomainIds;

    }
    getDay(num) {
      return projectConstants.myweekdaysSchedule[num];
    }
    arrageScheduleforDisplay(schedule_arr) {
      const timebase: any = [];
      for (let i = 0; i < schedule_arr.length; i++) {
        const timeindx = schedule_arr[i]['sTime'].replace(/\s+/, '') + schedule_arr[i]['eTime'].replace(/\s+/, '');
        if (timebase[timeindx] === undefined) {
          timebase[timeindx] = new Array();
          timebase[timeindx].push(schedule_arr[i]);
        } else {
          timebase[timeindx].push(schedule_arr[i]);
        }
      }
      for (const obj in timebase) {
        if (obj) {
          const len = timebase[obj].length;
          for (let i = 0; i < len; i++) {
            for (let j = i + 1; j < len; j++) {
              if (timebase[obj][j].day < timebase[obj][i].day) {
                const tempobj = timebase[obj][i];
                timebase[obj][i] = timebase[obj][j];
                timebase[obj][j] = tempobj;
              }
            }
          }
        }
      }
      const displaysch = [];
      let pday = 0;
      for (const obj in timebase) {
        if (obj) {
          let curstr = '';
          let gap = 0;
          for (let i = 0; i < timebase[obj].length; i++) {
            if (i === 0) {
              curstr = this.getDay(timebase[obj][i].day);
              pday = timebase[obj][i].day;
            } else {
              const diffs = timebase[obj][i].day - pday;
              if (diffs > 1) {
                if (gap >= 1) {
                  if (curstr.includes((this.getDay(pday)))) {
                  } else {
                    curstr = curstr + ' - ' + this.getDay(pday);
                  }
                }
                curstr = curstr + ', ' + this.getDay(timebase[obj][i].day);
              } else {
                if (i === (timebase[obj].length - 1)) {
                  curstr = curstr + ' - ' + this.getDay(timebase[obj][i].day);
                }
                gap++;
              }
              pday = timebase[obj][i].day;
            }
          }
          displaysch.push({ 'time': timebase[obj][0]['sTime'] + ' - ' + timebase[obj][0]['eTime'], 'dstr': curstr, 'indx': obj, 'recurrtype': timebase[obj][0]['recurrtype'] });
        }
      }
      return displaysch;
    }
    storeCustomererData(data) {
      this.customerData = {};
      this.customerData = data;
    
    }
    retriveCustomerData() {
      return this.customerData;
    }
    storeOfferDataData(data) {
      this.offerData = {};
      this.offerData = data;
    
    }
    retriveOfferData() {
      return this.offerData;
    }
    storeSpData(data) {
      this.spData = {};
      this.spData = data;
    
    }
    retriveSpData() {
      return this.spData;
    }
    getchannelsNames(channel,channels) {
      this.channelsNames = [];
      for (let i = 0; i < channels.length; i++) {
        this.channelsNames.push({ 'channel': channels[i].displayName });
      }
      return this.channelsNames;
  
    }
  }
